var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Star } from 'src/lib/astronomical/Star';
import { Planet } from 'src/lib/astronomical/Planet';
import { System } from 'src/lib/systems/System';
var StarSystem = /** @class */ (function (_super) {
    __extends(StarSystem, _super);
    function StarSystem(data) {
        var _this = _super.call(this, data.id, data.name, data.type) || this;
        _this.planets = [];
        _this.star = new Star(data.star);
        data.planets.forEach(function (planetData) { return _this.planets.push(new Planet(planetData)); });
        return _this;
    }
    StarSystem.prototype.getCenter = function () {
        return this.star;
    };
    StarSystem.prototype.getCenterBody = function () {
        return this.star.get3DBody();
    };
    StarSystem.prototype.getPlanets = function () {
        return this.planets;
    };
    StarSystem.prototype.getPlanetById = function (id) {
        return this.planets.filter(function (planet) { return planet.id === id; })[0];
    };
    StarSystem.prototype.getPlanetByName = function (name) {
        return this.planets.filter(function (planet) { return planet.name === name; })[0];
    };
    StarSystem.prototype.getPlanetBodies = function () {
        var arr = [];
        this.planets.forEach(function (planet) { return arr.push(planet.get3DBody()); });
        return arr;
    };
    StarSystem.prototype.setPlanetsPosition = function () {
        var date = new Date(); // 추후 외부에서 인자로 받는 날짜로 바꿀 것
        this.planets.forEach(function (planet) { return planet.setPositionByDate(date); });
    };
    return StarSystem;
}(System));
export { StarSystem };
